// src/app/hooks/filter/queries.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetFilterParamsQuery, useLazyGetFilterQuery } from '../../services';
import { setFilter, setFilterParams } from '../../slices';

export const useGetFilterMainData = (id: number) => {
  const { isLoading: filterLoading } = useGetFilter(id);
  const { isLoading } = useGetFilterParams();

  return {
    isLoading: isLoading || filterLoading,
  };
};

export const useGetFilter = (id: number, fetch = true) => {
  const dispatch = useDispatch();
  const [getFilter, { data: filter, isLoading }] = useLazyGetFilterQuery();

  useEffect(() => {
    if (fetch && id) {
      getFilter(id);
    }
  }, [id]);

  useEffect(() => {
    if (filter) dispatch(setFilter(filter));
  }, [filter]);

  return {
    filter,
    isLoading,
    getFilter,
  };
};

export const useGetFilterParams = () => {
  const dispatch = useDispatch();

  const { data: params, isLoading, refetch } = useGetFilterParamsQuery();

  useEffect(() => {
    if (params) {
      dispatch(setFilterParams(params.filter));
    }
  }, [params]);

  return { isLoading, params, get: refetch };
};

// Filter hooks file - helpers moved to apiHelpers.ts
